/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1LocationStatesQueryResponse,
  GetApiV1LocationStates401,
  GetApiV1LocationStates500,
} from "../../types/locationStateController/GetApiV1LocationStates.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1LocationStates } from "../../clients/locationStateController/getApiV1LocationStates.ts";

export const getApiV1LocationStatesQueryKey = () =>
  [{ url: "/api/v1/location/states" }] as const;

export type GetApiV1LocationStatesQueryKey = ReturnType<
  typeof getApiV1LocationStatesQueryKey
>;

export function getApiV1LocationStatesQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1LocationStatesQueryKey();
  return queryOptions<
    GetApiV1LocationStatesQueryResponse,
    ResponseErrorConfig<GetApiV1LocationStates401 | GetApiV1LocationStates500>,
    GetApiV1LocationStatesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1LocationStates({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todos os estados cadastrados com o nome do país, ordenados por nome. **(Requer Authorization para autenticação)**
 * @summary Listar estados (Requer Authorization para autenticação)
 * {@link /api/v1/location/states}
 */
export function useGetApiV1LocationStates<
  TData = GetApiV1LocationStatesQueryResponse,
  TQueryData = GetApiV1LocationStatesQueryResponse,
  TQueryKey extends QueryKey = GetApiV1LocationStatesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1LocationStatesQueryResponse,
        ResponseErrorConfig<
          GetApiV1LocationStates401 | GetApiV1LocationStates500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1LocationStatesQueryKey();

  const query = useQuery(
    {
      ...getApiV1LocationStatesQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiV1LocationStates401 | GetApiV1LocationStates500>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
